import CollectionLayoutsModal from './CollectionLayoutsModal';

export default CollectionLayoutsModal;
